import { Component, Input, OnInit, inject } from '@angular/core';
import { AppStateService } from 'src/app/core/services/app-state.service';

import { AppDirection } from 'src/app/core/types/app-direction.type';

@Component({
    selector: 'list-group-item',
    templateUrl: './list-group-item.component.html',
    styleUrls: ['./list-group-item.component.scss'],
    standalone: false
})
export class ListGroupItemComponent implements OnInit {
  appStateService = inject(AppStateService);

  @Input() type: 'outline' | 'fill' = 'fill';
  @Input() label: string;
  @Input() labelClass: string = 'tw-text-gray-600 dark:tw-text-gray-300';
  @Input() value: any;
  @Input() isShowValue: boolean = true;
  @Input() numberSeparator: boolean = false;
  @Input() direction: AppDirection;
  @Input() showValueInMaxOneRow: boolean = false;
  @Input() hasCurrency: boolean = false;
  @Input() paddingClass: string = '!tw-py-3';
  @Input() marginClass: string = '!tw-my-2';
  @Input() valueMaxWidth: string;

  spacingClasses: string;

  constructor() {}

  ngOnInit(): void {
    this.spacingClasses = this.paddingClass + ' ' + this.marginClass;
  }

  getValueClassNames() {
    let classNames: string = '';

    classNames += this.direction == 'rtl' ? 'dir-rtl' : 'dir-ltr tw-text-left';
    classNames += this.showValueInMaxOneRow ? ' max-width-value' : '';

    if (this.valueMaxWidth) {
      classNames += ' ' + this.valueMaxWidth;
    }

    return classNames;
  }
}
